export default () => {

  if ($('.experience-brightview-item').length) {

    $('.experience-brightview-item').on('mouseenter focus blur mouseleave', (e) => {
      $(e.currentTarget).attr('data-open', 'true').siblings().attr('data-open', 'false');
    });

  }

};
